import { useTranslation } from "@ncino/pax-ui";
import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/shared/components/PageHeader";
import { CheckCircleIcon } from "@phosphor-icons/react";

export const Route = createFileRoute("/tasks/")({
  staticData: {
    breadcrumb: { title: ({ t }) => t("breadcrumbs.tasks"), icon: CheckCircleIcon },
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("tasks");

  return <PageHeader title={t("tasksPage.title")} />;
}
